import React from 'react';
import PropTypes from 'prop-types';
import { get, map, upperFirst } from 'lodash';
import { JsonLdScript } from 'components/atoms';

export function FacilitySchema({ facility, phone }) {
	const street2Suffix = facility.location.streetAddress2
		? `, ${facility.location.streetAddress2}`
		: '';
	const streetAddress = `${facility.location.streetAddress1}${street2Suffix}`;

	const facilitySchema = {
		'@context': 'https://schema.org',
		'@type': 'SelfStorage',
		'@id': `${facility.url}#`,
		url: facility.url,
		name: facility.name,
		image: facility.images.length
			? `https://images.selfstorage.com/small-compress/${facility.images[0]}`
			: '',
		telephone: get(phone, 'formattedNumber'),
		address: {
			'@type': 'PostalAddress',
			streetAddress,
			addressLocality: facility.location.city,
			addressRegion: facility.location.state,
			postalCode: facility.location.zip,
		},
		...(get(facility, 'reviews.average') &&
			get(facility, 'reviews.number') && {
				aggregateRating: {
					'@type': 'AggregateRating',
					worstRating: 0,
					bestRating: 5,
					ratingValue: facility.reviews.average,
					reviewCount: facility.reviews.number,
				},
			}),
		openingHours: facility.inNetwork
			? map(
					get(facility, 'hours.office', []),
					(hour, key) =>
						`${upperFirst(key.substr(0, 2))} ${hour.open}-${hour.closed}`,
				)
			: '',
	};

	return <JsonLdScript schema={facilitySchema} />;
}

FacilitySchema.propTypes = {
	facility: PropTypes.object.isRequired,
	phone: PropTypes.object,
};

export default FacilitySchema;
